module.exports = __webpack_public_path__ + "img/HomeWithBinacular-Nobg.ee463be5.png";